import {clsx} from 'clsx';
import S from 'styles/layout-utils.less';

import type {List, Map} from 'immutable';

export type Layout = 'LAYOUT_HORIZONTAL' | 'LAYOUT_VERT' | 'LAYOUT_PIP' | 'LAYOUT_FLOW' | 'LAYOUT_QUAD';
export const LAYOUTS = {
    HOR: 'LAYOUT_HORIZONTAL',
    VERT: 'LAYOUT_VERT',
    PIP: 'LAYOUT_PIP',
    FLOW: 'LAYOUT_FLOW',
    QUAD: 'LAYOUT_QUAD',
} satisfies {[key: string]: Layout};

export type LayoutPropertiesLayout = {
    videoClass: number;
    styleClass: string;
    styleObj?: unknown;
};

type LayoutProperties = {
    containerClass: string;
    layouts: LayoutPropertiesLayout[];
};

export class LayoutUtils {
    static availableLayouts = (numFeeds: number): string[] => {
        const layouts = [];
        switch (numFeeds) {
            // @ts-expect-error TS(7029) FIXME: Fallthrough case in switch.
            case 4:
                layouts.push(LAYOUTS.QUAD);
            // falls through
            // @ts-expect-error TS(7029) FIXME: Fallthrough case in switch.
            case 3:
                layouts.push(LAYOUTS.FLOW);
            // falls through
            case 2:
                layouts.push(LAYOUTS.PIP);
                layouts.push(LAYOUTS.HOR);
                layouts.push(LAYOUTS.VERT);
        }

        return layouts;
    };

    static layoutProperties = (
        videoLayout: Layout,
        files: List<unknown>,
        offFeeds: Map<unknown, unknown>,
    ): LayoutProperties => {
        switch (videoLayout) {
            case LAYOUTS.VERT: {
                const container = S.container;
                const layoutArray = [];
                for (let i = 0; i < files.size; i++) {
                    layoutArray.push({
                        videoClass: 0,
                        styleObj: {
                            width: '100%',
                            height: 100 / (files.size - offFeeds.size) + '%',
                        },
                    });
                }
                return {
                    containerClass: container,
                    layouts: layoutArray,
                };
            }
            case LAYOUTS.QUAD: {
                const container = clsx(S.container, S.layoutQuad);
                const layoutArray = [];
                for (let i = 0; i < files.size; i++) {
                    layoutArray.push({
                        videoClass: 0,
                        styleClass: S.layoutQuadInner,
                        styleObj: {
                            width: '50%',
                            height: '50%',
                        },
                    });
                }
                return {
                    containerClass: container,
                    layouts: layoutArray,
                };
            }
            case LAYOUTS.PIP: {
                const container = clsx(S.container, S.layoutPIP);
                const layoutArray = [];
                layoutArray.push({
                    videoClass: 0,
                    styleClass: S.layoutPIPLeft,
                });
                for (let i = 0; i < 3; i++) {
                    layoutArray.push({
                        videoClass: i,
                        styleClass: S['layoutPIPRight' + i],
                    });
                }
                return {
                    containerClass: container,
                    layouts: layoutArray,
                };
            }
            case LAYOUTS.FLOW: {
                const container = clsx(S.container, S.layoutFlow);

                const layoutArray = [];
                layoutArray.push({
                    videoClass: 0,
                    styleClass: S.layoutFlowLeft,
                });

                if (files.size >= 4) {
                    for (let i = 0; i < files.size - 1; i++) {
                        layoutArray.push({
                            videoClass: i,
                            styleClass: S['layoutFlowRight' + i],
                        });
                    }
                } else {
                    for (let i = 0; i < 2; i++) {
                        layoutArray.push({
                            videoClass: i,
                            styleClass: S['layoutFlowRightCentered' + i],
                        });
                    }
                }
                return {
                    containerClass: container,
                    layouts: layoutArray,
                };
            }
            case LAYOUTS.HOR:
            default: {
                const container = clsx(S.container, S.layoutHor);

                const layoutArray = [];
                for (let i = 0; i < files.size; i++) {
                    layoutArray.push({
                        videoClass: 0,
                        styleClass: S.layoutHorInner,
                    });
                }

                return {
                    containerClass: container,
                    layouts: layoutArray,
                };
            }
        }
    };
}
